import { pointsFormatter } from "../../helpers";
import styles from "./PlayerInfoComponent.module.css";
import { crown_Icon } from "../../assets/icons";
import { useCurrentLineup, useCurrentLineupIndex } from "../../hooks/lineups";
import { useCurrentDraft } from "../../hooks/drafts";
import { useUserId } from "../../hooks/useUserId";

function PlayerInfoComponent(props: {
  playerName: string;
  globalRank: number;
  totalPoints: number;
  freeTrades: number;
  style?: React.CSSProperties;
}) {
  const { data: currentDraft } = useCurrentDraft();
  const userId = useUserId();
  const { currentLineupIndex } = useCurrentLineupIndex();
  const { data: currentLineup } = useCurrentLineup(userId, {
    draftId: currentDraft?.draftId,
    lineupIndex: currentLineupIndex,
  });
  const { globalRank, totalPoints, style } = props;
  return (
    //ELLE TODO FROM DIYANKA: ADD THE NAME OF THE LINEUP TO THIS COMPONENT
    <div className={styles["player-info"]} style={style}>
      <img className={styles["crown-icon"]} src={crown_Icon} alt="" />
      <span className={styles["rank"]}>Global Rank: {globalRank}</span>
      <span className={styles["name"]}>
        {currentLineup?.name ?? `Lineup ${currentLineupIndex}`}
      </span>
      <span className={styles["points"]}>
        Total Points: {pointsFormatter(totalPoints)}
      </span>
    </div>
  );
}

export default PlayerInfoComponent;
